define('GameDayCore/GDModel/enums/baseball/SimpleStatusCodes',{
    //Pregame
    X: 0,
    C: 0,
    D: 0,
    S: 0,
    P: 0,
    // In game - but suspended
    T: 50,
    U: 50,
    //In game
    M: 50,
    N: 100,
    I: 100,
    //Wrapup
    O: 200,
    F: 200,
    Q: 200,
    R: 200,
    W: 200
});
